module.exports = __webpack_public_path__ + "static/media/grusom.fc200437.m4a";